import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { SlotImage } from '@/features/designer/components/SlotImage'

export function ApplyCard() {
  return (
    <div className="rounded-lg bg-gradient-to-br from-brand-yellow-light to-background dark:from-brand-yellow-dim overflow-hidden h-full">
      <div className="flex h-full flex-col">
        <SlotImage
          slotKey="homepage-join"
          className="min-h-64 flex-1"
          alt="Join One Day Dance"
          fallback={
            <div className="min-h-64 flex-1 bg-gradient-to-br from-brand-yellow-light to-brand-yellow-dim dark:from-brand-yellow-dim dark:to-background" />
          }
        />

        <div className="p-10 flex flex-col">
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-brand-orange">
            Apply
          </p>
          <h2 className="mb-4 text-3xl font-bold tracking-tight">Join One Day Dance</h2>
          <p className="mb-8 text-muted-foreground leading-relaxed">
            Applications for Season 6 are open. We&apos;re looking for choreographers, dancers,
            videographers, photographers, and interns. We never charge application or audition fees.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/applications">
              <Button size="lg">Applications</Button>
            </Link>
            <Link to="/sign-in">
              <Button size="lg" variant="outline">Login</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export function ApplySection() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <ApplyCard />
      </div>
    </section>
  )
}
